(function () {
  var params = new URLSearchParams(window.location.search);
  var productsParam = params.get('products');

  if (!productsParam || window.__GEARONIMO_META_CHECKOUT_REDIRECTING) {
    return;
  }

  window.__GEARONIMO_META_CHECKOUT_REDIRECTING = true;

  function loadMap(callback) {
    if (window.GEARONIMO_META_CHECKOUT_MAP) {
      callback();
      return;
    }

    if (!window.GEARONIMO_META_CHECKOUT_MAP_URL) {
      callback();
      return;
    }

    var script = document.createElement('script');
    script.src = window.GEARONIMO_META_CHECKOUT_MAP_URL;
    script.onload = callback;
    script.onerror = callback;
    document.head.appendChild(script);
  }

  function lookup(rawId) {
    var map = window.GEARONIMO_META_CHECKOUT_MAP || {};
    var id = String(rawId || '').trim();
    var decoded = id;

    try {
      decoded = decodeURIComponent(id.replace(/\+/g, ' '));
    } catch (error) {
      decoded = id.replace(/\+/g, ' ');
    }

    var candidates = [
      id,
      decoded,
      decoded.toLowerCase(),
      decoded.replace(/\s+/g, '+'),
      id.replace(/\+/g, ' ')
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      if (map[candidates[i]]) {
        return map[candidates[i]];
      }
    }

    if (/^\d{8,}$/.test(decoded)) {
      return { variant_id: decoded };
    }

    return {};
  }

  function normalizeMatch(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, ' ')).trim().toLowerCase();
    } catch (error) {
      return String(value || '').replace(/\+/g, ' ').trim().toLowerCase();
    }
  }

  function productJsonUrl(productUrl) {
    var target = new URL(productUrl, window.location.origin);
    var path = target.pathname.replace(/\/$/, '');

    if (!path || path.slice(-3) === '.js') {
      return target.pathname;
    }

    return path + '.js';
  }

  function resolveLineVariant(line) {
    if (line.variantId || !line.productUrl || !window.fetch) {
      return Promise.resolve(line);
    }

    return window.fetch(productJsonUrl(line.productUrl), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) {
        return line;
      }

      return response.json();
    }).then(function (product) {
      var variants = product && product.variants ? product.variants : [];
      var wanted = normalizeMatch(line.rawId);
      var selected = variants.find(function (variant) {
        return normalizeMatch(variant.id) === wanted || normalizeMatch(variant.sku) === wanted;
      }) || variants.find(function (variant) {
        return variant.available;
      }) || variants[0];

      if (selected && selected.id) {
        line.variantId = String(selected.id);
      }

      return line;
    }).catch(function () {
      return line;
    });
  }

  function appendTracking(url, extraParams) {
    var target = new URL(url, window.location.origin);
    target.searchParams.set('utm_source', 'meta');
    target.searchParams.set('utm_medium', 'shop_buy_now');
    target.searchParams.set('utm_campaign', 'facebook_instagram_shop');

    Object.keys(extraParams || {}).forEach(function (key) {
      if (extraParams[key]) {
        target.searchParams.set(key, extraParams[key]);
      }
    });

    return target.pathname + target.search + target.hash;
  }

  loadMap(function () {
    var lines = productsParam.split(',').map(function (part) {
      var separatorIndex = part.lastIndexOf(':');
      var rawId = separatorIndex > -1 ? part.slice(0, separatorIndex) : part;
      var rawQuantity = separatorIndex > -1 ? part.slice(separatorIndex + 1) : '1';
      var quantity = parseInt(rawQuantity, 10);
      var entry = lookup(rawId);

      if (!quantity || quantity < 1) {
        quantity = 1;
      }

      return {
        rawId: rawId,
        quantity: quantity,
        productUrl: entry.url || '',
        variantId: entry.variant_id || entry.variantId || ''
      };
    }).filter(function (line) {
      return line.rawId;
    });

    if (!lines.length) {
      window.__GEARONIMO_META_CHECKOUT_REDIRECTING = false;
      return;
    }

    if (lines.length === 1 && lines[0].productUrl) {
      window.location.replace(appendTracking(lines[0].productUrl, {
        variant: lines[0].variantId
      }));
      return;
    }

    Promise.all(lines.map(resolveLineVariant)).then(function (resolvedLines) {
      var cartLines = resolvedLines.filter(function (line) {
        return line.variantId;
      });

      if (cartLines.length === resolvedLines.length) {
        var cartPath = cartLines.map(function (line) {
          return encodeURIComponent(line.variantId) + ':' + encodeURIComponent(line.quantity);
        }).join(',');

        window.location.replace('/cart/' + cartPath + '?storefront=true&utm_source=meta&utm_medium=shop_buy_now&utm_campaign=facebook_instagram_shop');
        return;
      }

      var fallbackProduct = resolvedLines.find(function (line) {
        return line.productUrl;
      });

      if (fallbackProduct) {
        window.location.replace(appendTracking(fallbackProduct.productUrl, {
          variant: fallbackProduct.variantId
        }));
        return;
      }

      window.location.replace('/collections/shop-all?utm_source=meta&utm_medium=shop_buy_now&utm_campaign=facebook_instagram_shop');
    });
  });
})();
